/*
 * Copyright 2026 Christopher Moore
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const API_KEY_STORAGE_KEY = 'pixelforge_api_key';
const SELECTED_TEXT_MODEL_KEY = 'pixelforge_selected_text_model';
const SELECTED_IMAGE_MODEL_KEY = 'pixelforge_selected_image_model';

export const getApiKey = (): string | null => {
  return localStorage.getItem(API_KEY_STORAGE_KEY);
};

export const setApiKey = (key: string): void => {
  localStorage.setItem(API_KEY_STORAGE_KEY, key);
};

export const removeApiKey = (): void => {
  localStorage.removeItem(API_KEY_STORAGE_KEY);
};

export const getSelectedTextModel = (): string | null => {
  return localStorage.getItem(SELECTED_TEXT_MODEL_KEY);
};

export const setSelectedTextModelStorage = (model: string): void => {
  localStorage.setItem(SELECTED_TEXT_MODEL_KEY, model);
};

export const getSelectedImageModel = (): string | null => {
  return localStorage.getItem(SELECTED_IMAGE_MODEL_KEY);
};

export const setSelectedImageModelStorage = (model: string): void => {
  localStorage.setItem(SELECTED_IMAGE_MODEL_KEY, model);
};
